export const colors = {
  fff_Mcolor: "#00EE13",
  fff_Scolor: "purple",
  black: "#000000",
  white: "#ffffff",
  grey: "#ebedf0",
  transparentBlack: "rgba(0,0,0,.25)",
};
